<script>
import ExpressionUtil from "../../util/ExpressionUtil";
export default {
  name: "Dispatcher",
  props: ["elementInfo", "detailModel"],
  computed: {
    // 控件属性
    displayProp: function() {
      if (this.elementInfo.detailIndex) {
        return this.$store.getters.elementPropData[
          "e" +
            this.elementInfo.elementIndex +
            "d" +
            this.elementInfo.detailIndex
        ];
      } else {
        return this.$store.getters.elementPropData[
          "e" + this.elementInfo.elementIndex
        ];
      }
    },
    // 明细信息
    displayDetailModel: function() {
      if (this.detailModel) {
        return this.detailModel;
      } else {
        return this.elementInfo.detailModel;
      }
    },
    // 控件可见
    visible: function() {
      if (this.displayProp) {
        switch (typeof this.displayProp.visible) {
          case "string":
            return ExpressionUtil.eval(
              this,
              "return " + this.displayProp.visible,
              this.displayDetailModel
            );
          case "boolean":
            return this.displayProp.visible;
        }
      }
      return true;
    }
  },
  /**
   * 渲染函数
   */
  render(createElement) {
    if (this.visible == false) {
      return null;
    }

    if (this.elementInfo.displayType == null) {
      console.error("displayType is null!");
      return null;
    }

    // 控件类型
    var componentType = "j2-" + this.elementInfo.displayType;

    // 创建控件
    var j2Component = createElement(componentType, {
      props: {
        "element-index": this.elementInfo.elementIndex,
        "detail-index": this.elementInfo.detailIndex,
        props: this.displayProp,
        "display-data": this.elementInfo.displayData,
        "detail-list": this.elementInfo.detailList,
        "detail-model": this.displayDetailModel
      }
    });

    if (this.elementInfo.elementAddon) {
      var elementAddon = JSON.parse(this.elementInfo.elementAddon);

      // 文字提示
      if (elementAddon.tooltip) {
        if (!elementAddon.tooltip.placement) {
          elementAddon.tooltip.placement = "top-start";
        }
        j2Component = createElement(
          "Tooltip",
          {
            props: elementAddon.tooltip
          },
          [j2Component]
        );
      }
    }

    if (this.elementInfo.detailAddon) {
      var detailAddon = JSON.parse(this.elementInfo.detailAddon);

      // 文字提示
      if (detailAddon.tooltip) {
        if (!detailAddon.tooltip.placement) {
          detailAddon.tooltip.placement = "top-start";
        }
        j2Component = createElement(
          "Tooltip",
          {
            props: detailAddon.tooltip
          },
          [j2Component]
        );
      }
    }

    return j2Component;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/core/Dispatcher.vue